var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3.78836,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0286 10.6691L11.519 17.1787C10.7215 17.9762 9.63993 18.4242 8.51213 18.4242C7.38433 18.4242 6.30273 17.9762 5.50525 17.1787C4.70778 16.3812 4.25977 15.2996 4.25977 14.1718C4.25977 13.044 4.70778 11.9624 5.50525 11.165L11.5757 5.09455C12.1073 4.56196 12.8288 4.26238 13.5813 4.26172C14.3338 4.26106 15.0558 4.55936 15.5884 5.09101C16.121 5.62266 16.4205 6.3441 16.4212 7.09663C16.4219 7.84916 16.1236 8.57113 15.5919 9.10372L9.50734 15.1741C9.24151 15.44 8.88098 15.5893 8.50505 15.5893C8.12911 15.5893 7.76858 15.44 7.50275 15.1741C7.23693 14.9083 7.08759 14.5478 7.08759 14.1718C7.08759 13.7959 7.23693 13.4354 7.50275 13.1695L13.5165 7.16288",
    stroke: "#616E85",
    strokeWidth: 1.26366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseFile);
export default __webpack_public_path__ + "static/media/ChooseFile.b328ec8f6d3c63806bdcfea1005f44d3.svg";
export { ForwardRef as ReactComponent };